import { render } from "./SectionComboard.vue?vue&type=template&id=ab056a34"
import script from "./SectionComboard.vue?vue&type=script&lang=js"
export * from "./SectionComboard.vue?vue&type=script&lang=js"

import "./SectionComboard.vue?vue&type=style&index=0&id=ab056a34&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__